/**
 * Custom Hook - useModelSearch
 * Handles model search functionality
 */

import { useState, useEffect, useMemo } from 'react';
import { Model } from '../models/Model';

export function useModelSearch(models: Model[]) {
  const [searchQuery, setSearchQuery] = useState('');

  /**
   * Filter models based on search query
   */
  const filteredModels = useMemo(() => {
    if (!searchQuery.trim()) {
      return models;
    }

    const query = searchQuery.toLowerCase();
    return models.filter(model =>
      model.model_name.toLowerCase().includes(query) ||
      model.provider.toLowerCase().includes(query) ||
      model.description.toLowerCase().includes(query) ||
      model.version.toLowerCase().includes(query)
    );
  }, [models, searchQuery]);

  /**
   * Clear search
   */
  const clearSearch = () => {
    setSearchQuery('');
  };

  return {
    searchQuery,
    setSearchQuery,
    filteredModels,
    clearSearch,
    hasSearchResults: filteredModels.length > 0,
    resultCount: filteredModels.length,
  };
}
